import { z } from 'zod';

import authService from '@/services/auth/auth';

import { apiRoutes } from './config';

const mindCoinsSchema = z.object({
  mindCoins: z.number(),
  lastUpdated: z.string(),
  refreshDate: z.string(),
});

export type MindCoins = z.infer<typeof mindCoinsSchema>;

export const getMindCoins = async () => {
  const { data } = await authService.get(apiRoutes.payments.mindCoins.me);

  return mindCoinsSchema.parse(data);
};

export const postMindCoinsCheckout = async () => {
  const { data } = await authService.post(
    apiRoutes.payments.mindCoins.checkout
  );
  return data;
};
